// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"fe7a9546","200":"37628ad0","460":"fe7a9546","506":"fe7a9546"}[chunkId] + ".chunk.css";
};